import { useEffect, useState } from 'react';
import CardIjinReadonly from './CardIjinReadonly';
import { normalizeIjin } from '../hooks/normalizeIjin';
import { isPendingIzin } from '../utils/izinApproval';
import { motion } from 'framer-motion';
import CardCarousel from './CardCarousel';

const ListIjinReadonly = ({ type = 'ijin' }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = () => {
    try {
      const raw = localStorage.getItem('ijin_pengajuan');
      const parsed = raw ? JSON.parse(raw) : [];

      const normalized = Array.isArray(parsed)
        ? parsed.map(normalizeIjin).filter(isPendingIzin)
        : [];

      const keuanganIds = ['kasbon', 'cicilan', 'lembur', 'piket_harian', 'perconnote'];
      const filtered = type === 'keuangan'
        ? normalized.filter(item => keuanganIds.includes(item.absen_id))
        : normalized.filter(item => !keuanganIds.includes(item.absen_id));

      setData(filtered);
    } catch (e) {
      console.error('Gagal membaca localStorage', e);
    } finally {
      setLoading(false);
    }
    };

    loadData();
    window.addEventListener('storage', loadData);
    window.addEventListener('badgeUpdate', loadData);

    return () => {
      window.removeEventListener('storage', loadData);
      window.removeEventListener('badgeUpdate', loadData);
    };
  }, [type]);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 40 }}>
        Memuat data...
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, x: -100 }}
      transition={{ duration: 0.3 }}
      style={{
        backgroundColor: '#ffffff',
        borderRadius: 24,
        margin: '0 auto 24px auto',
        padding: '24px 20px',
        width: '100%',
        maxWidth: 450,
        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
        border: '1px solid #cbd5e1',
        boxSizing: 'border-box'
      }}
    >
      {/* Header */}
      <div style={{
        textAlign: 'center',
        marginBottom: 32,
        paddingBottom: 24,
        borderBottom: '1px solid #f0f0f0'
      }}>
        <h2 style={{
          fontWeight: 700,
          fontSize: 18,
          margin: '0 0 2px 0',
          color: '#111827',
        }}>
          {type === 'ijin' ? 'Daftar Pengajuan Izin' : 'Daftar Pengajuan Keuangan'}
        </h2>
        <p style={{
          margin: 0,
          color: '#9ca3af',
          fontSize: 13
        }}>
          {data.length} pengajuan menunggu persetujuan
        </p>
      </div>
      {data.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '40px 20px',
            background: '#f9fafb',
            borderRadius: 16,
            border: '1px dashed #e5e7eb',
            width: '100%',
            maxWidth: '100%',
            margin: '0 auto',
            boxSizing: 'border-box'
          }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>📄</div>
            <p style={{ margin: 0, fontWeight: 600, color: '#4b5563', fontSize: 15 }}>
              Belum ada pengajuan
            </p>
            <p style={{ margin: '4px 0 0 0', color: '#9ca3af', fontSize: 13 }}>
              {type === 'ijin' ? 'Tidak ada data riwayat pengajuan izin' : 'Tidak ada data riwayat pengajuan keuangan'}
            </p>
          </div>
        ) : (
          <CardCarousel itemStyle={{ minWidth: 280, maxWidth: 320 }}>
            {data.map(item => (
              <CardIjinReadonly key={item.id} item={item} />
            ))}
          </CardCarousel>
        )}
      {/* Footer */}
      {/* <div style={{
        marginTop: 0,
        paddingTop: 20,
        borderTop: '1px solid #f0f0f0',
        textAlign: 'center',
        color: '#8c8c8c',
        fontSize: 13
      }}>
        <p style={{ margin: 0 }}>
          Klik area <span style={{ fontWeight: 500, color: '#1890ff' }}>"Berikan Persetujuan"</span> untuk memverifikasi setiap pengajuan
        </p>
      </div> */}
    </motion.div>
  );
};

export default ListIjinReadonly;
